import { ChangeEventHandler, MouseEventHandler, ReactNode } from 'react';

interface IFormCheckboxField {
    id: string,
    label: string,
    isChecked: boolean,
    onChange?: ChangeEventHandler,
    onClick?: MouseEventHandler,
    additionalContent?: ReactNode
}

/**
 * Checkbox field.
 */
const FormCheckboxField = (props: IFormCheckboxField) => {
    return (
        <div className="mb-4 text-sm text-gray-500 flex items-center justify-between">
            <div className="flex items-center">
                <input
                    id={ props.id }
                    type="checkbox"
                    className="mr-2 cursor-pointer"
                    checked={ props.isChecked }
                    onChange={ props.onChange }
                    onClick={ props.onClick }
                />
                <label htmlFor={ props.id } className="mt-px cursor-pointer">{ props.label }</label>
            </div>

            { props.additionalContent }
        </div>
    )
};

export default FormCheckboxField;